module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-s-blue.9a3f7861.svg";